import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
}) => {
  const siteName = 'Flash Funding';
  const baseUrl = 'https://www.flashfunding.loan';
  const hasSiteName = !!title && title.toLowerCase().includes(siteName.toLowerCase());
  const fullTitle = title ? (hasSiteName ? title : `${title} | ${siteName}`) : `${siteName} | Commercial Asset Finance Australia`;
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const safeDescription = description || 'Commercial asset finance solutions for Australian businesses.';

  useEffect(() => {
    // Update document title
    document.title = fullTitle;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', safeDescription);
    }
    
    // Update meta keywords
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      }
    }
    
    // Update canonical
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', fullCanonical);
    }
    
    // Update OG tags
    const updateMetaProperty = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      }
    };
    
    updateMetaProperty('og:title', fullTitle);
    updateMetaProperty('og:description', safeDescription);
    updateMetaProperty('og:url', fullCanonical);
    updateMetaProperty('twitter:title', fullTitle);
    updateMetaProperty('twitter:description', safeDescription);
    updateMetaProperty('twitter:url', fullCanonical);
    
  }, [fullTitle, safeDescription, keywords, fullCanonical]);

  return null;
};

export default SEO;
